const productPayment = {
    successTitle: 'Payment completed!',
    successMessage: 'Your order has been received and confirmed',
    nextSteps: 'Next Steps',
    emailConfirmation: 'You will receive a confirmation email',
    orderProcessing: 'Your order is being processed',
    shippingUpdate: 'You will receive shipping updates',
    viewOrders: 'View Orders',
    continueShopping: 'Continue Shopping',
    questions: 'Questions?',
    contactUs: 'Contact Us',
    cancelledTitle: 'Payment Cancelled',
    cancelledMessage: 'Your payment has been cancelled',
    whatHappened: 'What happened?',
    noCharge: 'No amount has been charged',
    cartPreserved: 'Your products are still in your cart',
    tryAgain: 'Try Again',
    returnToCart: 'Return to Cart',
    needHelp: 'Need Help?'
};

export default productPayment;
